import { useSelector } from "react-redux";
import ShortcutHelp from "../../../Shortcuts/ShortcutHelp";
import Navbar from "../../Components/Navbar/Navbar";
import ToggleModalComponent from "../../Components/ToggleModalComponent/ToggleModalComponent";
import "./Layout.scss";
import VersionCheck from "../../Components/FormComponents/VersionCheck/VersionCheck";

const Layout = (props) => {
  const isOpen = useSelector((state) => state.sidebarOpen);

  return (
    <>
      <Navbar />
      <VersionCheck />
      {/* <HamburgerDrawer /> */}
      <div className={isOpen.sidebarOpen ? "addLoadEntryTablePage" : "adjustTable"}>{props.children}</div>
      <ToggleModalComponent />
      <ShortcutHelp />
    </>
  );
};

export default Layout;
